export default {
    devices_main_id: 'Id',
    devices_main_label: 'Label',
    devices_main_device_model: 'Device Model',
    devices_main_status: 'Status',
    devices_main_company: 'Account',
    devices_main_devices: 'Devices',
    devices_main_advanced_filters: 'Advanced Filters',
    devices_main_apply: 'Apply',
    devices_main_tags: 'Tags',
    devices_main_active_devices_only: 'Active Devices Only',
    devices_main_yes: 'Yes',
    devices_main_no: 'No',
    devices_main_authenticate_cloud: 'Login as Customer',
    devices_main_re_sync_backend_information: 'Re-sync Backend Information',
    devices_main_sim_number: "SIM #",
    devices_main_serial: "Serial",
    devices_main_sim_provider: "SIM Provider",
    devices_main_network: "Network",
    devices_main_linked_device_label: "Paired Unit",
    devices_main_linked_device: "GPS Unit ESN",
    devices_main_linked_camera: "Camera ESN",
    devices_main_createdOn: "Created At",
    devices_main_updatedOn: "Updated At",
    devices_main_unitTime: "Unit Time",
    devices_main_serverTime: "Server Time",
    devices_main_lastMessageTime: "Last Message Time",
    devices_main_age: "Age",
    devices_main_edit: "Edit",
    devices_main_manufacturer: "Manufacturer",
    devices_main_manufacturers: "Manufacturers",
    devices_main_sim_provider_account: "SIM Provider Account",
    devices_main_network_type: "Network Type",
    devices_main_bulk_pairing: "Bulk Pairing",
    devices_main_bulk_vidfleet_configuration: "Bulk VidFleet Configuration",
    devices_main_bulk_vidfleet_config_device_model: "Only devices with the same device model can be selected",
    devices_main_bulk_vidfleet_config_device_manufacturer: "Action available only for VidFleet devices",
    devices_main_activate_sim_card: "Activate Camera's SIM Card",
    devices_main_activate_sim_card_message_error: "The manufacturer of the device must be vidfleet",
    devices_main_bulk_vidfleet_configuration_upload_mode: "Bulk VidFleet Configuration Upload Mode",
    devices_main_import_and_assign: "Import & Assign",
    devices_main_bulk_actions: "Bulk Actions",
    devices_main_change_sim_provider: "Change SIM Provider",
    devices_main_global_star_error: "Global Star devices do not have this action available",
    devices_main_calamp_error: "Only Calamp devices are available",
    devices_main_import_device_result: "Import Device Result",
    devices_main_assign_firmware: "Assign Firmware",
    devices_main_assign_firmware_error_label: "The hardware version of the devices must be the same",
    devices_main_device_info: "Device Info",
    devices_main_device_raw_data: "Raw Data",
    devices_main_device_commands: "Commands",
    devices_main_edit_swap_sim_card: "Edit & Swap Sim Card",
    devices_main_smartWitness_error: "SmartWitness devices cannot be edited or selected for action",
    devices_main_only_vidfleet: "The manufacturer of the devices must be VidFleet",
    devices_main_send_command: "Send Command",
    devices_main_the_manufacturer_of_the_devices_must_be_the_same: "The manufacturer of the devices must be the same",
    devices_main_the_manufacturer_of_the_devices_must_be_different_from_vidfleet: "The manufacturer of the devices must be different from VidFleet",
    devices_main_general_info: "General Information",
    devices_main_firmware: "Firmware",
    devices_main_mark_as_rma: "Mark as RMA",
    devices_main_only_vidfleet_and_smartwitness: "The manufacturer of the devices must be VidFleet or SmartWitness",
    devices_main_mode: "Mode",
    devices_main_show_in_web: "Show In Web",
    devices_main_reference: "Reference",
    devices_main_show_last_reading_info: "Show Last Reading Info",
    devices_main_revert_rma: "Revert RMA",
    devices_main_mass_sms: "Mass SMS",
    devices_main_puls_group: "Group",
    devices_main_same_manufacturer_device_model: "The manufacturer and the device model of the devices must be the same",
    devices_main_select_devices: "Please select the devices first",
    devices_main_bulk_features: "Bulk Features",
    devices_main_camera_actions: "Camera Actions",
    devices_main_change: "Change",
    devices_main_commands: "Commands",
    devices_main_brand: "Brand",
    devices_main_warning_message_calamp_api: "The selected devices must be of the same calamp api",

    devices_main_all: "All",
    devices_main_esn: "ESN",
    devices_main_imei: "IMEI",
    devices_main_iccid: "ICCID",
    devices_main_company: "Company",
    devices_main_label: "Label",
    devices_main_reference: "Reference",
    devices_main_hardware_version: "Hardware Version",
    devices_main_installed: "Installed",
    devices_main_pending_installed: "Pending Installation",
    devices_main_installed_on: "Installed On",
    devices_main_installed_only: "Installed Only",
    devices_main_coverage_score: "Diagnostic Score",
    devices_main_coverage_updated_on: "Diagnostic Updated on",
    devices_main_create_diagnostic_device: "Create Diagnostic",
    devices_main_maintenance_warnings: "Warnings",
    devices_main_maintenance_warnings_label: "With Maintenance Warnings Only",
    devices_main_maintenance_health_score: "Health Score",
    devices_main_live_mode: "Live Mode",
    devices_main_live_mode_straming: "Streaming",
    devices_main_live_mode_photo: "Photo",
    devices_main_only_att: "Only are allowed cameras with SIM provider AT&T ",
    devices_main_vin: "VIN",
    devices_main_phone_number: "SIM Phone Number",
    devices_main_battery_level: "Battery Level",
    devices_main_vin: "VIN",
    devices_main_id: "Id",
    devices_main_sd_card_error: "SD card error",
    devices_main_live_streaming: "Live Streaming",
    devices_main_offline: "Offline",
    devices_main_last_event: "Last Event",
    devices_main_bulk_tags: "Bulk Tags",
    devices_main_billing_account: "Billing Account",
    devices_main_address: "Address",
    devices_main_assign_unassign_billing_account: "Assign/Unassign Billing Account",
    devices_main_different_brands: "The devices must be from the same brand to assign or unassign billing account",
    devices_main_unit_type: "Unit Type",

};



